import { render, staticRenderFns } from "./SectionChampCinema.vue?vue&type=template&id=0d216900&"
import script from "./SectionChampCinema.vue?vue&type=script&lang=js&"
export * from "./SectionChampCinema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports